module.exports = __webpack_public_path__ + "static/media/shapes_06.685ed787.svg";